// extracted by mini-css-extract-plugin
module.exports = {"chat-talk-container":"chatTalk_chat-talk-container__pO5bH"};